import { render, staticRenderFns } from "./AppSelfCheckReportForm.vue?vue&type=template&id=2a68f7b6"
import script from "./AppSelfCheckReportForm.vue?vue&type=script&lang=ts"
export * from "./AppSelfCheckReportForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports